module.exports = __webpack_public_path__ + "gm992021/img/jianghu-8.png?dc79a10e";